import L from "leaflet";
import {message as Message} from "@/js/utils/message";
import {layerServiceURL} from "@/utils/mapUtil/layerServiceURL";

/**
 * 根据不同省份添加地图边界
 * @param {*} map  地图实例
 * @param {*} city  省份名称
 * @param {*} filter  县级边界图层过滤条件
 * @param {*} center  边界图层中心点
 * @returns
 */
export function addMapMarkers(map, city, filter, center) {
  if (city.includes('四川')) {
    console.log('加载四川省区域边界数据');
    addMapBoundary(map, filter, center, layerServiceURL['sichuan_county'].url, layerServiceURL['sichuan_county'].layerName);
  } else if (city.includes('黑龙江')) {
    console.log('加载黑龙江区域边界数据');
    addMapBoundary(map, filter, center, layerServiceURL.heilongjiang_county.url, layerServiceURL.heilongjiang_county.layerName);
  } else if (city.includes('吉林')) {
    console.log('加载吉林区域边界数据');
    addMapBoundary(map, filter, center, layerServiceURL.jilin_county.url, layerServiceURL.jilin_county.layerName);
  } else if (city.includes('哈尔滨')) {
    console.log('加载辽宁区域边界数据');
    addMapBoundary(map, filter, center, layerServiceURL.liaoning_county.url, layerServiceURL.liaoning_county.layerName);
  } else {
    Message({message: `暂无${city}区域数据！`, type: 'error'});
  }

}

/**
 * 添加地图边界
 * @param {*} map  地图实例
 * @param {*} filter  边界图层过滤条件
 * @param {*} center  边界图层中心点
 * @param {*} url  县级边界地图服务地址
 * @param {*} layerName  县级边界地图图层名称
 * @returns
 */
export function addMapBoundary(map, filter, center, url, layerName) {

// 1. 创建遮罩图层（显示除当前区域外的所有区域）
  const maskLayer = L.tileLayer.wms(layerServiceURL.china_mask.url, {
    layers: layerServiceURL.china_mask.layerName,
    format: 'image/png',
    transparent: true,
    maxNativeZoom: 10,
    cql_filter: `county<>'${filter}'`, // 反向筛选
  });

  // 2. 创建高亮图层（仅显示当前区域）
  const highlightLayer = L.tileLayer.wms(url, {
    layers: layerName,
    format: 'image/png',
    transparent: true,
    // maxNativeZoom: 20,
    cql_filter: `county='${filter}'` // 正向筛选
  });

  // 添加两个图层到地图
  map.addLayer(maskLayer);
  map.addLayer(highlightLayer);

  // 确保高亮图层始终在最上层
  maskLayer.bringToFront();

  // 设置地图中心点
  const point = center.split(",");
  map.setView([point[1], point[0]], 10);
}

// 加载GeoJson数据
function addAreaPolygons(map, data, style) {
  return L.geoJSON(data, {
    style: style
  }).addTo(map);
}

let lastZoom = null; // 记录上一次的缩放层级

/**
 * 根据缩放层级加载对应的行政区划边界，并优化加载逻辑避免重复销毁/加载
 * @param {Object} map - Leaflet 地图实例
 * @param {Object} layersRef - 存储图层引用的对象（例如：{ provinceLayer: null, ... }）
 * @param {Object} zoomRanges - 存储图层数据（例如：{layerType: 'service/json', range: [5, 7], layerName: 'province', url: 'http://139.9.137.227:8080/geoserver/mapBoundary/wms?'}）
 */
export function handleZoomForBoundary(map, layersRef, zoomRanges) {
  const currentZoom = map.getZoom();

  console.log('当前缩放层级：', currentZoom);
  console.log('上次缩放层级：', lastZoom);

  if (currentZoom === lastZoom) {
    return; // 缩放层级未变，无需处理
  }

  let targetConfig = null;

  // 判断当前应该加载哪个层级
  for (const config of zoomRanges) {
    const [min, max] = config.range;
    if (currentZoom >= min && currentZoom < max) {
      targetConfig = config;
      break;
    }
  }

  // 清除所有其他图层，除了当前要保留或新增的
  for (const config of zoomRanges) {
    const { layerType, layerName, url } = config;
    if (config === targetConfig) {
      // 如果已有图层且之前未加载，则跳过；否则加载新图层
      if (!layersRef[layerName]) {
        console.log('加载图层：', layerName);
        if (layerType === 'service') {
          layersRef[layerName] = L.tileLayer.wms(url, {
            layers: layerName,
            format: 'image/png',
            transparent: true,
          });
          map.addLayer(layersRef[layerName]);
          // if (layerName === 'township') {
          //
          // } else {
          //   layersRef[layerName] = L.tileLayer.wms(url, {
          //     layers: layerName,
          //     format: 'image/png',
          //     transparent: true,
          //   });
          //   map.addLayer(layersRef[layerName]);
          // }
        } else {
          layersRef[layerName] = addAreaPolygons(map, url, { color: "#6495ED", fill: false, weight: 5 });
        }
      }
    } else {
      if (layersRef[layerName]) {
        map.removeLayer(layersRef[layerName]);
        layersRef[layerName] = null;
      }
    }
  }

  lastZoom = currentZoom;
}
